/** Safari 15.0–15.3 has AbortController, but drops abort reasons. */
export function installAbortCompatibility(Controller = AbortController, Signal = AbortSignal) {
  if (!("reason" in Signal.prototype)) {
    const reasons = new WeakMap<AbortSignal, unknown>();
    const nativeAbort = Controller.prototype.abort;
    Object.defineProperty(Signal.prototype, "reason", { configurable: true, get(this: AbortSignal) {
      return this.aborted ? reasons.get(this) : undefined;
    } });
    Controller.prototype.abort = function(reason?: unknown) {
      if (!this.signal.aborted) reasons.set(this.signal, reason === undefined ? new DOMException("请求已取消", "AbortError") : reason);
      nativeAbort.call(this);
    };
    Signal.abort = (reason?: unknown) => { const controller = new Controller(); controller.abort(reason); return controller.signal; };
  }
  if (typeof Signal.prototype.throwIfAborted !== "function") {
    Object.defineProperty(Signal.prototype, "throwIfAborted", { configurable: true, writable: true,
      value(this: AbortSignal) { if (this.aborted) throw this.reason; } });
  }
}
